module.exports = __webpack_public_path__ + "static/media/bank-charges-fees.3bd49a3a.svg";